<template>
	<div  v-bem="'background'">
		<div v-bem.description="'default'">
    <div v-bem.skew-top="'default'" ></div><div v-bem.skew-bottom="'default'" ></div>
      <div v-bem.image="'default'" :style="background">&nbsp;</div>
      <div v-bem.digit="'default'"><slot name="digit"></slot></div>
      <div v-bem.full-info="'default'">
        <slot>
         Текст 
        </slot>
      </div>
		</div>
    <div v-bem.right-image="'default'" :style="background"><div v-bem.right-arrow="'default'"></div></div>
	</div>
</template>
<script>
export default {
  name: 'indicator',
  props: ['image'],
  computed: {
    background: function () {
      return {
        'background-image': this.image
      }
    }
  }
}
</script>
<style>
@import '../style.css';
@use saladcss-bem;

@b indicator {
	@m background {
      background-repeat:no-repeat;
	}
	@e image {
    @m default {
			width:100%;
			height:30vw;  
      background-position: center center;
      background-repeat:no-repeat;
      background-size:cover;  
    }
	}
  @e digit {
		@m default {
			text-align:center;
			font-size:32pt;
			display: block;
			position:relative;
      font-family: Impact, Arial, Helvetica, sans-serif; 
      color: #235a8a;
		}
	  @m default::before {
			content:"";
			position:absolute;
			z-index:100;
			display:block;
			width: 0; 
			height: 0; 
			left:50%;
			top:-15px;
			margin-left:-15px;
			margin-right:auto;
			border-left: 15px  solid transparent;
			border-right: 15px  solid transparent;
			border-bottom: 15px  solid white;
		}
	}	
	@e description {
		@m default {
			background-color:white;
      padding:10px;
      z-index:100;
		}	
	}
	@e full-info {
		@m default {
		 font-size: 16pt; 
     font-family: Open Sans, Arial, Helvetica, sans-serif;
     color: #555555;
     z-index: 100;
     position: relative;
		}
	}
  @e right-image {
    @m default {
      display:none;
    }
  }
  @e right-arrow {
    @m default {
      display:none;
    }
  }
}
@media all and (orientation:portrait){
  @b indicator {
    @e image {
      @m default {
        height:50vw;  
      }
    }
  }
  
}

@media(--ss) {
	@b indicator {
    @e digit {
      @m default {
        font-size: 48pt;
      }
      @m default::before {
        border-left: 30px  solid transparent;
        border-right: 30px  solid transparent;
        border-bottom: 30px  solid white;
        top:-30px;
        margin-left:-30px;
      }
    }	
  }
}

@media (--ls) {
	@b indicator {
		@e image {
			@m default {
				display:none;
			}		
		}
		@e description {
			@m default {
				//margin-left:10px;
        width:50%;
        /*height:300px;*/
				position:relative;
        padding:10px;
        /* border-bottom:1px solid white;
        border-image: url('../assets/triangle.svg');
        border-right: 30px solid transparent;*/
			  min-height:300px;
      }
			@m default::before {
        width:0;
        height:0;
        border-top: 30px solid transparent;
			  border-left: 30px  solid red ;
        border-right: 30px  solid transparent;
        border-bottom: 30px  solid transparent;
        top:50px;
        margin-left:100%;
        position:absolute;
        z-index:1000;
      }
		}
    @e right-image {
      @m default {
        width: 50%;
        position: absolute;
        left:50%;
        height:100%;
        top:0;
				display:block;
        background-position: center center;
        background-repeat:no-repeat;
        background-size:cover;  
      }
    }
    @e right-arrow {
      @m default {
				width: 0;
				height: 0;
				border-top: 60px solid transparent;
				border-left: 40px solid white;
				border-right: 60px solid transparent;
				border-bottom: 60px solid transparent;
				top: 50%;
				left: 0%;
				position: absolute;
				z-index: 99;
				display: block;
				margin-top: -60px;
      }
    }
		@e skew-top {
			@m default {
				background-color:white;
				width:45%;
				height:50%;
				left: 55%;
        top:0%;
        position:absolute;
				transform: skewX(30deg);
        border-bottom:1px solid #fffffe;
        filter: blur(0);
        display:none;
			}
		}
		@e skew-bottom {
			@m default {
				background-color:white;
				width:45%;
				height:calc(50% - 2px);
				top:50%;
				left:55%;
				position:absolute;
				transform: skewX(-30deg);
        border-top: 1px white solid;
        filter: blur(0);
        display:none;
			}
		}
		@m background {
			margin:0;
			position:relative;  
			background-position: right center;
			background-repeat:no-repeat;
			background-size:50%;
		}
		@e digit {
			@m default {
				font-size: 38pt;
				font-weight:bolder;
			}
      @m default::before {
        display: none;
      }
		}
	}
}
@media (--xs) {
	@b indicator{
		@e skew-top {
			@m default {
				width:45%;
			}
		}
		@e skew-bottom {
			@m default {
				width:45%;
			}
		}
		@e digit {
			@m default {
				font-size: 52pt;	
			}
    }
    @e description {
      @m default {
        width:50%;
      }
    }  
	}
}

</style>




// WEBPACK FOOTER //
// src/components/Indicator.vue